export type EntryState = 'active' | 'completed' | 'pending_reflection';

export type TimelineItem = {
  id: number;
  text: string;
  state: EntryState;
  createdAt: string;
  scheduledAt: string | null;
  source: 'text' | 'voice' | 'remote';
  attachment?: { id: number; name: string; mimeType?: string | null } | null;
};

export type AppSettings = {
  cloudEndpoint: string;
  configEndpoint: string;
  voiceEndpoint: string;
  embeddingsEndpoint: string;
  llmEndpoint: string;
  serviceToken: string;
  userId: number;
  userKey: string;
  userName: string;
};

export const defaultSettings: AppSettings = {
  cloudEndpoint: 'https://app.journeyup.ru/api/data',
  configEndpoint: 'https://app.journeyup.ru/api/config',
  voiceEndpoint: 'https://srv1.journeyup.ru',
  embeddingsEndpoint: 'https://app.journeyup.ru/api/embeddings',
  llmEndpoint: 'https://app.journeyup.ru/api/llm',
  serviceToken: 'notoken',
  userId: 1,
  userKey: 'default',
  userName: 'Основной пользователь',
};
